import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuditDialogComponent } from 'app/audit-dialog/audit-dialog.component';
import { CreateVoucherPostingDialogComponent } from 'app/create-voucher-posting-dialog/create-voucher-posting-dialog.component';

@Component({
  selector: 'app-create-voucher-posting-preview',
  templateUrl: './create-voucher-posting-preview.component.html',
  styleUrls: ['./create-voucher-posting-preview.component.scss']
})
export class CreateVoucherPostingPreviewComponent implements OnInit {
  @Input() 
  response: any;
  voucherData: any = {};
  debitDataSource = new MatTableDataSource<any>();
  creditDataSource = new MatTableDataSource<any>();
  approval_status: any;
  company_name:any;
  company_address:any;
  hostname:any;
  voucher_posting_id:number;
  audit_status:number;
  access_list: any;
  is_auditor:boolean=false;
  audit: number ;
  remark: string = '';
  index: number;
  allData:any[];
  isDuplicate: boolean;
  duplicate_btn: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { view: any,voucher_posting_id:number,auditstatus:number,remark:string ,index:number,allData:any,duplicate?:boolean},
    private apiService: ApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateVoucherPostingPreviewComponent>,
  ) {
    this.audit=this.data?.auditstatus
    this.remark=this.data?.remark
    this.index=data?.index
    this.allData=data.allData
    // alert(data?.duplicate);
    this.duplicate_btn=data?.duplicate == false ? false : true;
  }

  ngOnInit(): void {
    this.processResponseData();
    this.setApprovalStatus();
    this.hostname = window.location.hostname;
    this.fetchcompany();
    this.voucherData = this.data.view;
    console.log("Voucher Data in Modal:", this.voucherData); 
    const accessListData = localStorage.getItem('accesslist');
    if (accessListData) {
      this.access_list = JSON.parse(accessListData);
      this.is_auditor=this.access_list[0]['is_auditor'];
      // alert(this.is_auditor);
    }
  }
  processResponseData(): void {
    this.apiService.voucherpostingview(this.data.view).subscribe(
      (response) => {
        this.voucherData = response.posting || {};
      },
      error => {
        console.error('Error fetching voucher data:', error);
      }
    );
  }
   navigate(direction: 'prev' | 'next') {
  const newIndex = direction === 'next' ? this.index + 1 : this.index - 1;
  if (newIndex < 0 || newIndex >= this.allData.length) return;
   this.index = newIndex;
  const newItem = this.allData[newIndex];
  const voucherId =  newItem.creation_voucher_id || newItem.id;

  this.apiService.getcreationepostdata(voucherId).subscribe((postData) => {
    this.index = newIndex;
    this.data.view = postData;
    this.voucher_posting_id = newItem.id;
    this.audit = newItem.is_audit || 0;
    this.remark = newItem?.audit?.remark || '';

    this.voucherData = postData;
    this.processResponseData();
  });
}

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  posting(): void {
    this.apiService.creationVoucherPosting(this.data.view).subscribe(
      response => {
        alert(response.message);
        console.log('Voucher Posting successfully:');
        this.dialogRef.close(response);
      },
      error => {
        console.error('Error posting voucher:', error);
      }
    );
  }

  setApprovalStatus(): void {
    this.apiService.approvalStatus(this.data.view.id).subscribe(
      response => {
        console.log('Approval Status:', response);
        console.log('Approval Statusddddd:', response.status);
        if(response.status == "Approved") {
          console.log('Approved');
          this.approval_status = true;
        } else {
          this.approval_status = false;
        }
      },
      error => {
        console.error('Error fetching approval status:', error);
        this.approval_status = false;
      }
    );
  }
  getTotal(items: any[]): number {
    return items.reduce((sum, item) => sum + parseFloat(item.amount), 0);
  }
  
    fetchcompany() {
    this.apiService.Companydetails(this.hostname).subscribe(
      (response) => {
        console.log('company_details',response);
        this.company_name = response.name;
        this.company_address = response.address;
        console.log(this.company_name,this.company_address);
      
      },
      (error) => {
        console.error('Error fetching  companydata:', error);
      }
    );
  }
 onClose(): void {
  this.dialogRef.close();
 }
  onSave(): void {
    // auditForm.submitted = true;
    if (!this.audit) {
      alert('Please Enter Audit type');
      return;
    }

    if (this.audit==2 && !this.remark ) {
      alert('Please Give remark');
      return;
    }
    const payload = {
      voucher_posting_id: this.data?.voucher_posting_id,
      audit: this.audit,
      remark: this.remark,
    };
    if (this.data?.voucher_posting_id) {
      this.apiService.audit(payload).subscribe(
        updatedAudit => {
          console.log('audit successfully:', updatedAudit);
          this.dialogRef.close({
            audit: this.audit,
            remark: this.remark,
          });
        },
        error => {
          console.error('Error updating statement:', error);
        }
      );

    }
  }
  
duplicateVoucher(voucherData?: any) {
  const dataToDuplicate = voucherData?.view || voucherData || this.data;
    const { voucher_id, id, ...rest } = dataToDuplicate;

  const payload = {
    ...rest,
    voucherType: voucher_id, 
    branch: dataToDuplicate.branch || dataToDuplicate.branch_id,
    debitSides: (dataToDuplicate.dr || dataToDuplicate.debitSides || dataToDuplicate.creation_voucher_debit || []).map((item: any) => ({ ...item, employee_id: item.employee_id })),
    creditSides: (dataToDuplicate.cr || dataToDuplicate.creditSides || dataToDuplicate.creation_voucher_credit || []).map((item: any) => ({ ...item, employee_id: item.employee_id })),
    uploadedFiles: dataToDuplicate.upload || [],
    narration: dataToDuplicate.narration || '',
    showInter: dataToDuplicate.showInter || false,
    voucherNo: null,
    type: 'create',
    operationType: 'create',
    selectedEmployees: dataToDuplicate.employee_id ? (dataToDuplicate.employee_id === 'string' ? dataToDuplicate.employee_id.split(',').map(Number) : dataToDuplicate.employee_id) : (dataToDuplicate.selectedEmployees || []),
    isDuplicate: true,
    originalVoucherId: id,

  };

  const dialogRef = this.dialog.open(CreateVoucherPostingDialogComponent, {
    width: '95%',
    height: '95%',
    maxWidth: '100%',
    data: payload
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.dialogRef.close(result);
    }
  });
}
}
